import axiosInstance from "./api/axiosInstance";

// const login = async (username, password) => {
//   const response = await axiosInstance.post('auth/login', { username, password });
//   console.log(response.data)
//   return response.data;
// };

const login = async (username, password, ipAddress) => {
  const response = await axiosInstance.post('auth/login', { username, password, ipAddress });
  console.log(response.data)
  return response.data;
};

const getClientData = async (username, connectionId) => {
  const config = { 
    headers: { "X-Username": username, "X-Connection-ID": connectionId } 
  };
  const response = await axiosInstance.get('auth/client', config);
  return response.data;
};

export const authService = {
  login,
  getClientData,
};

